import { render, staticRenderFns } from "./AddDepoModal.vue?vue&type=template&id=6d61667a&"
import script from "./AddDepoModal.vue?vue&type=script&lang=js&"
export * from "./AddDepoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports